import React, { useEffect, useReducer } from 'react';
import { Switch, Route, BrowserRouter, Redirect } from 'react-router-dom';
import ProductPurchase from "../screens/product-purchase/ProductPurchase"
import { SemContext } from "../context/SemContext";
import { initialState, SemReducer } from "../reducer/SemReducer";
import { setCoupons, setOfferData, setSemSettings, updateSettings } from "../actions/actions";
import { PromoPagesMapping } from "./promo-page-mapping";
import i18n from '../../../app/js/utils/i18n';
import ScrollToTop from '../../../app/js/utils/scroll-to-top.js';
import Routes from "./routes";
import queryString from 'query-string';

const LandingPage = () => {

  const [state, dispatch] = useReducer(SemReducer, initialState);
  useEffect(async () => {
    try {
      const variant = localStorage.getItem("sem_variant");
      const campaign_code = localStorage.getItem("campaign_code");
      localStorage.setItem('from_landing_page', true);
      const semSettings = await setSemSettings({ variant, ...(campaign_code && campaign_code != "undefined" && { campaign_code }) })
      dispatch(semSettings);
      
      i18n.changeLanguage(semSettings.payload.preferred_language);
      const offerSettings = await setOfferData({ variant, preferred_language: semSettings.payload.preferred_language, ...(campaign_code && campaign_code != "undefined" && { campaign_code }) });
      dispatch(offerSettings);
      
      const coupons = offerSettings && offerSettings.payload.coupons && offerSettings.payload.coupons.length ? offerSettings.payload.coupons : [];
      const coupon = coupons && coupons.length ? coupons[0] : null;
      dispatch(setCoupons(coupons));
      
      let { password_left_header_text = "", password_left_sub_header_text = "", password_header_text = "", hide_password_sub_header = "" ,trial_days = "" } = offerSettings && offerSettings.payload && offerSettings.payload.properties || {};
      const finalTrialDays = trial_days ? parseInt(trial_days) : 7 ;
      dispatch(updateSettings({trial_days: finalTrialDays}));
      localStorage.setItem("offerData", JSON.stringify({ redeem_by: coupon && coupon.redeem_by, trailDays: finalTrialDays, password_left_header_text, password_left_sub_header_text, password_header_text, hide_password_sub_header  }))
    }

    catch (err) {
      console.error(err);
    }

  }, [])

  const trackPromoPageEvents = (category, properties, sendGA) =>{
    const landingPageUrl = localStorage.getItem("landing_page_url");
    if(category)
      trackAnalyticsEvent(category, { 'landingpage_details': landingPageUrl,...(properties)}, sendGA)
  }

  return (
    <SemContext.Provider value={{ state, dispatch }}>
      <BrowserRouter>
        <ScrollToTop>
          <Switch>
            {
              <Route path={Routes.PURCHASE_ROUTE} render={(props) => {
                const queryParams = queryString.parse(props.location.search);
                const campaign_code = queryParams && queryParams["campaign_code"];
                const variant = queryParams && queryParams["variant"];
                localStorage.setItem("campaign_code", campaign_code);
                localStorage.setItem("sem_variant", variant);
                localStorage.setItem("landing_page_url", JSON.stringify(window.location.pathname));
                if(state.offerLoaded){
                  return <ProductPurchase />
                }
              }} />
            }
            {
              <Route exact path="/landing_page/:version" render={(props) => {
                const variant = (props.match && props.match.params.version) || "1";
                const queryParams = queryString.parse(props.location.search);
                const campaign_code = queryParams && queryParams["campaign_code"];
                localStorage.setItem("campaign_code", campaign_code);
                localStorage.setItem("sem_variant", variant);
                localStorage.setItem("landing_page_url", JSON.stringify(window.location.pathname));

                if(state.offerLoaded){
                  const Component = state.settings.promo_page ? PromoPagesMapping[state.settings.promo_page] : PromoPagesMapping["default"];
                  return <Component {...props} offer={state.settings} trackPromoPageEvents={trackPromoPageEvents} />
                }
              }
              } />
            }

            <Route exact path="*" component={() => {
              window.location.pathname = window.location.pathname == '/' ? '' : '/404';
              return null;
            }} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    </SemContext.Provider>

  );
};


export default LandingPage;
